@if (entities) {
  @if (entities && Array.from(entities).length > 0) {
    <span>
      <mat-label class="with-icon"><i class="bhi-job"></i> Associated {{ jobOrderLabel }}</mat-label>
      <mat-select (ngModelChange)="modelChange($event)"
        [(ngModel)]="chosenEntity"
        placeholder="Select record...">
        @for (option of entities; track option) {
          <mat-option [value]="option">
            {{ option.jobOrder.id }} | {{ option.displayIdentifier }}
          </mat-option>
        }
      </mat-select>
    </span>
  }
}
